import { stableTextHash } from '../../utils/stableTextHash';

const clean = (value = '') => String(value ?? '').trim();

export const buildKnowledgeEvidenceDocumentId = ({
  childId = '',
  sourceCollection = '',
  sourceId = '',
  sourceItemId = '',
  sourceBlockId = '',
  sourceSentenceIndex = '',
  knowledgeType = '',
  profileField = '',
} = {}) => {
  const sourceLocation = clean(sourceItemId)
    || clean(sourceBlockId)
    || (sourceSentenceIndex === 0 || sourceSentenceIndex
      ? `sentence:${clean(sourceSentenceIndex)}`
      : '');
  const parts = [
    clean(childId),
    clean(sourceCollection),
    clean(sourceId),
    sourceLocation,
    clean(knowledgeType),
    clean(profileField),
  ];

  if (parts.slice(0, 5).some((part) => !part)) return '';

  const evidenceKey = JSON.stringify(parts);
  const reverseKey = [...evidenceKey].reverse().join('');
  return `evidence_${stableTextHash(evidenceKey)}_${stableTextHash(reverseKey)}`;
};
